import { BTN_BORDER_RADIUS, BTN_BORDER_WIDTH, BTN_BOX_SHADOW, BTN_BOX_SHADOW_SIZE } from './btn/component-lib.esm.js';
import tinycolor from 'tinycolor2';
const PROFILE_BG_GRADIENTS = {
  LIGHT: 'linear-gradient(rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.88))',
  DARK: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.88))'
};
function getProfileBorderRadius(size) {
  return BTN_BORDER_RADIUS[size];
}
function getProfileBorderWidth(size) {
  return BTN_BORDER_WIDTH[size];
}
function getProfileBoxShadow(variant, settings) {
  const {
    bgColor,
    borderWidth,
    borderColor,
    shadowStyle
  } = settings;
  const key = `${variant}${shadowStyle ? '-' : ''}${shadowStyle ? shadowStyle : ''}`;
  const btnBgColor = tinycolor(bgColor);
  const btnBorderColor = tinycolor(borderColor);
  let shadowColor = '0deg 0% 0%';
  if (variant === 'hard-shadow') {
    const color = borderWidth === 'none' ? btnBgColor : btnBorderColor;
    shadowColor = (color.isDark() ? color.lighten(20) : color.darken(20)).toRgbString();
  } else if (variant === '3d') {
    shadowColor = (btnBgColor.isDark() ? btnBgColor.lighten(15) : btnBgColor.darken(15)).toRgbString();
  }
  return {
    shadow: BTN_BOX_SHADOW[key] || 'none',
    size: BTN_BOX_SHADOW_SIZE[key] || '0px',
    color: shadowColor
  };
}
export { PROFILE_BG_GRADIENTS, getProfileBorderRadius, getProfileBorderWidth, getProfileBoxShadow };